export default "__VITE_ASSET__C6e2zDZS__"